import React, { useState, useEffect } from 'react';
import ApiEngine from "../../util/ApiEngine";
import { ApiKey, ApiUrl } from "../../util/Constant";
import { stringIsNullOrEmpty } from '../../util/Util';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const GifFloatingComponent = () => {
  const { t } = useTranslation();
  const [idLiveLink, setIdLiveLink] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [flicker, setFlicker] = useState(true);
  let communicationChannelList = useSelector((state) => state.appState.communicationChannelList);

  useEffect(() => {
    getIdrProductionLink();
  }, [])


  const getIdrProductionLink = async () => {
    let responseJson = await ApiEngine.get(ApiUrl._API_GET_IDR_PRODUCTION_LINK);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let data = responseJson[ApiKey._API_DATA_KEY];
      setIdLiveLink(data);
    }
  }

  const handleLinkOnClick = (link) => {
    if (stringIsNullOrEmpty(link)) {
      let tlink = communicationChannelList.filter((x) => { return x.channelName.includes("Telegram") });
      window.open(tlink[0].cta, "_blank", 'Telegram');
    }
    else {
      window.open(link, "_blank", 'idlive');
    }
  }

  const handleClick = () => {
    setIsOpen(!isOpen);
    setFlicker(false);
  }

  return (
    <>
      <div className={`gif-container ${isOpen ? "open" : ""}`}>
        <div className={`attention ${flicker && "flicker"}`}>
          {t("CLICK_HERE")}
        </div>
        <div className="hamburg" onClick={() => { handleClick() }}>
          <div className="bar1"></div>
          <div className="bar2"></div>
          <div className="bar3"></div>
        </div>
        <ul>
          <li>
            <div className="telegram-container">
              <img src="/img/ug/floating/telegram.webp" alt="telegram" onClick={() => { handleLinkOnClick() }} />
            </div>
            <div className="text">Telegram</div>
          </li>
          {/*<li>*/}
          {/*  <div className="idlive-container">*/}
          {/*    <img src="/img/ug/floating/idlive.gif" alt="idlive" onClick={() => { handleLinkOnClick(idLiveLink) }} />*/}
          {/*  </div>*/}
          {/*  <div className="text">{t("ALTERNATIVE_LINK")}</div>*/}
          {/*</li>*/}
        </ul>
      </div>
    </>
  );
};

export default GifFloatingComponent;